<template>
    <div>
        哈萨克斯坦 文莱
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>
